export default {"src":"/_next/static/media/chicken_money.a24d8223.svg","height":417,"width":381};